import { Box, Typography } from '@branch-messenger/willow-ui'
import { useSuspenseQuery } from '@tanstack/react-query'

import { userQueryOptions } from '@/queries/auth'

export const AccountDropdownUserInfo = () => {
  const {
    data: { email, first_name, last_name },
  } = useSuspenseQuery(userQueryOptions)

  return (
    <Box $px={4} $pt={4} $pb={6}>
      <Typography $size="xs" $bold>{`${first_name} ${last_name}`}</Typography>
      <Typography $size="xs" $color="textMuted">
        {email}
      </Typography>
    </Box>
  )
}
